// extracted by mini-css-extract-plugin
export default {"Mesures":"EditionMesuresConsultation_Mesures__Iajqw"};